<p-confirmdialog />
<p-toast />
<p-dialog
  header="Change Plan"
  (onShow)="dialogShown()"
  (onHide)="dialogClosed()"
  [modal]="true"
  [(visible)]="visible"
  [style]="{ width: '25rem' }"
>
<p-blockui [blocked]="isLoading" />
<span class="p-text-secondary block mb-8">Customer Name : {{customerName}}</span>
<span class="p-text-secondary block mb-8"
    >Current Plan : {{currentPlanName ?? "Unknown"}}</span
  >
  <p-accordion [(value)]="selectedPlanSlug" (onOpen)="panelOpened($event)" (onClose)="panelClosed($event)">
    <p-accordion-panel
      *ngFor="let plan of plans"
      [value]="plan.slug"
    >
      <p-accordion-header>{{ plan.name }}</p-accordion-header>
      <p-accordion-content>
        <p class="m-0">{{ plan.download_speed }}</p>
      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>
  <ng-template #footer>
    <p-button
      label="Cancel"
      [text]="true"
      severity="secondary"
      (click)="visible.set(false)"
    />
    <p-button
      label="Change Plan"
      [disabled]="currentPlanSlug === selectedPlanSlug || selectedPlanSlug === ''"
      [outlined]="true"
      severity="primary"
      (click)="changePlan()"
    />
  </ng-template>
</p-dialog>
